import withGlobalContext from "./app-hoc";
import useGlobalContext from "./hook";

export default withGlobalContext;
export { useGlobalContext };
